import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import MaterialTable from '@material-table/core';
import Button from '@mui/material/Button';
import PatientCell from './PatientCell';
import ServiceCell from './ServiceCell';
import StatusCell from './StatusCell';
import { useSnackbar } from 'notistack';

const ConsultSearchResultsTable = ({ config, props }) => {
    const { enqueueSnackbar } = useSnackbar();
    const [consults, setConsults] = useState([]);
    useEffect(() => {
        if(props.results === "Patient not found"){
            setConsults([]);
            enqueueSnackbar('Patient does not exists', { variant: 'error' });
        }
        else if(props.results == "Expired"){
            setConsults([]);
            enqueueSnackbar('Patient file search has expired. Please search again.', { variant: 'error' });
        }
        else{
            setConsults(props.results)
        }

    }, [props]);

    const navigate = useNavigate();

    const columns = [
        {
            field: 'patient_details',
            title: 'PATIENT DETAILS',
            render: (rowData) => <PatientCell consult={rowData} />,
        },
        {
            field: 'tariff_description',
            title: 'SERVICE',
            render: (rowData) => <ServiceCell consult={rowData} />,
        },
        {
            field: 'consult_status',
            title: 'STATUS',
            render: (rowData) => <StatusCell status={rowData.consult_status} />,
        },
    ];

    const handleViewConsult = (consult) => {
        navigate(`/consult-review/${consult.consult_id}`);
    };

    return (
        <MaterialTable
            data={consults}
            columns={columns}
            title="Search Results"
            actions={[
                (rowData) => ({
                    label: 'view',
                    onClick: handleViewConsult,
                }),
            ]}
            components={{
                Action: (props) => {
                    const buttonProps = props.action.action(props.data);
                    return buttonProps.hidden ? null : (
                        <Button
                            color="primary"
                            variant="contained"
                            style={{ marginRight: 15 }}
                            disabled={props.data.consult_status !== 'completed'}
                            onClick={() => buttonProps.onClick(props.data)}
                        >
                            {buttonProps.label}
                        </Button>
                    );
                },
            }}
            options={{
                headerStyle: {
                    color: '#999999',
                    fontSize: '11px',
                    fontWeight: 600,
                    lineHeight: '15px',
                },
                search: false,
                actionsColumnIndex: -1,

            }}
        />
    );
};

export default ConsultSearchResultsTable;
